// Used to help prevent the need for ts-ignores everywhere
import { MobileBridgeClient } from "./MobileBridgeClient"
import { getCarrotBridgePayload, getGlobal, initGlobalCallbacks } from "./shared"

const appWindow: Record<string, any> = window

export class IOSMobileBridgeClient implements MobileBridgeClient {
  static bridge = appWindow?.webkit?.messageHandlers?.carrotBridge
  static isIOSMobileClient = () => Boolean(this.bridge)

  constructor() {
    initGlobalCallbacks()
  }

  helpCenter = (token, zdType, id) => {
    const payload = getCarrotBridgePayload(token, zdType, id)
    appWindow.webkit.messageHandlers.carrotBridge.postMessage(payload)
  }

  isBiometricsCapable = async () => {
    const payload = {
      action: "isBiometricsCapable"
    }
    getGlobal()._isBiometricsCapable = null

    await IOSMobileBridgeClient.bridge.postMessage(payload)
    return getGlobal()._isBiometricsCapable
  }

  isBiometricLoginAlreadyConfigured = async () => {
    const payload = {
      action: "isBiometricLoginAlreadyConfigured"
    }
    getGlobal()._isBiometricLoginAlreadyConfigured = null

    await IOSMobileBridgeClient.bridge.postMessage(payload)
    return getGlobal()._isBiometricLoginAlreadyConfigured
  }

  disableBiometrics = async () => {
    const payload = {
      action: "disableBiometrics"
    }
    await IOSMobileBridgeClient.bridge.postMessage(payload)
  }

  attemptBiometricsCredentialsRetrieval = async (login) => {
    getGlobal()._login = login

    getGlobal()._bioAuthenticatedUsername = null
    getGlobal()._bioAuthenticatedPassword = null

    const payload = {
      action: "attemptBiometricsCredentialsRetrieval"
    }
    await IOSMobileBridgeClient.bridge.postMessage(payload)
  }

  showBiometricsEnrollment = async (username, password, biometricEnrollmentSuccess, biometricEnrollmentFailure) => {
    getGlobal()._biometricEnrollmentSuccess = biometricEnrollmentSuccess
    getGlobal()._biometricEnrollmentFailure = biometricEnrollmentFailure
    const payload = {
      action: "showBiometricsEnrollment",
      data: {
        username: `${username}`,
        password: `${password}`
      }
    }
    await IOSMobileBridgeClient.bridge.postMessage(payload)
  }
}
